import * as XLSX from 'xlsx';

export const exportToXLS = (xlsData, fileName) => {
	const fileExtension = '.xlsx';
	const ws = XLSX.utils.json_to_sheet(xlsData);
	const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
	XLSX.writeFile(wb, fileName + fileExtension, { bookType: 'xlsx', type: 'array' });
};

export const XLSFromFileToJSON = async (file) => {
	const arrayBuffer = await file.arrayBuffer();
	var workbook = XLSX.read(arrayBuffer, { type: 'buffer', cellDates: true });
	const sheetName = workbook.SheetNames[0];
	return XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 'A' });
};
